import styled from 'styled-components'
import breakpoint from 'components/breakpoint'

const getViewHeight = props => props.theme.input.email.height || props.theme.input.height
const getViewBackground = props => props.theme.input.email.backgroundColor
const getViewBorder = props => props.theme.input.email.border
const getViewBorderRadius = props => props.theme.input.email.borderRadius || 0
const getViewFontSize = props => props.theme.font.mobile.size
const getEmailColor = props => props.theme.input.email.color
const getEmailFontSize = props => props.theme.input.email.fontSize
const getEmailMargin = props => props.theme.input.email.margin || '0 12px'

const ChangeEmailView = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  height: ${getViewHeight};
  background: ${getViewBackground};
  border: ${getViewBorder};
  font-size: ${getViewFontSize};
  border-radius: ${getViewBorderRadius};
`

const ChangeEmailText = styled.p`
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
  margin: ${getEmailMargin};
  color: ${getEmailColor};
  font-size: ${getEmailFontSize};
  padding-right: 70px;
`

const getButtonHeight = props => props.theme.input.email.button.height
const getButtonRight = props => props.theme.input.email.button.right
const getButtonBackgroundColor = props => props.theme.input.email.button.backgroundColor
const getButtonColor = props => props.theme.input.email.button.color
const getButtonBorder = props => props.theme.input.email.button.border
const getButtonBorderRight = props => props.theme.input.email.button.borderRight
const getButtonBorderRadius = props => props.theme.input.email.button.borderRadius || 0
const getButtonFontSize = props => props.theme.input.email.button.fontSize
const getButtonFontFamily = props => props.theme.input.email.button.fontFamily || 'inherit'
const getButtonTextDecoration = props => props.theme.input.email.button.textDecoration

const getButtonHoverColor = props => props.theme.input.email.button.hoverColor
const getButtonHoverBackgroundColor = props => props.theme.input.email.button.hoverBackgroundColor || '#FFFFFF'
const getButtonHoverBorder = props => props.theme.input.email.button.hoverBorder
const getButtonHoverBorderRight = props => props.theme.input.email.button.hoverBorderRight
const getButtonHoverFontFamily = props => props.theme.input.email.button.hoverFamily || getButtonFontFamily(props)
const getButtonBackgroundImage = props =>
  props.theme.input.email.overrideBackground ||
  `linear-gradient(to right, rgba(255, 255, 255, 0), ${getViewBackground(props)})`
const getButtonPadding = props => props.theme.input.email.button.padding || '0 12px'
const getButtonWidth = props => props.theme.input.email.button.width
const getDesktopWidth = props => props.theme.input.email.button.desktopWidth || props.theme.input.email.button.width
const getDesktopPadding = props =>
  props.theme.input.email.button.desktopWidth === 'auto' ? '0 30px' : getButtonPadding(props)

const ChangeEmailButton = styled.button`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${getButtonHeight};
  top: 0;
  bottom: 0;
  margin: auto;
  padding: ${getButtonPadding};
  right: ${getButtonRight};
  background-color: ${getButtonBackgroundColor};
  color: ${getButtonColor};
  border: ${getButtonBorder};
  border-right: ${getButtonBorderRight};
  border-radius: ${getButtonBorderRadius};
  font-size: ${getButtonFontSize};
  font-family: ${getButtonFontFamily};
  text-decoration: ${getButtonTextDecoration};
  cursor: pointer;
  outline: none;
  width: ${getButtonWidth};

  ${breakpoint('portrait')`
    width: ${getDesktopWidth};
    padding: ${getDesktopPadding};
  `};

  &:hover {
    color: ${getButtonHoverColor};
    border: ${getButtonHoverBorder};
    border-right: ${getButtonHoverBorderRight};
    background-color: ${getButtonHoverBackgroundColor};
    font-family: ${getButtonHoverFontFamily};
  }

  &:before {
    content: '';
    position: absolute;
    left: -40px;
    height: 20px;
    width: 39px;
    cursor: text;
    background-image: ${getButtonBackgroundImage};
  }
`

export {ChangeEmailView, ChangeEmailText, ChangeEmailButton}
